module.exports = "./img/87f1d7d4a66a200bdd4381c3b8dae3cc.jpg";